import { useEffect, useState } from 'react';
import { notifications } from '@mantine/notifications';
import { atomWithStorage } from 'jotai/utils';
import { useAtom } from 'jotai';

// this is just here to explicitly define the type so an empty "features" array won't complain
type Feature = {
  date: string;
  name: string;
  description: string;
};

const features: Feature[] = [
  // { date: '2024-11-17', name: 'Feature 1', description: 'Description 1' }, // Format
];

const FEATURES_TO_SHOW = 5;
const seenFeaturesAtom = atomWithStorage<string[]>('seen_features', []);

const featureListItem = (title: string, description: string | null) => (
  <li>
    <span className="font-medium">• {title}</span> - {description}
  </li>
);

export function useShowNewFeatures() {
  const [seenFeatures, setSeenFeatures] = useAtom(seenFeaturesAtom); // doesn't populate immediately!
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  useEffect(() => {
    if (!hasMounted) {
      return;
    }

    const latestFeatures = features.slice(-FEATURES_TO_SHOW);
    const newFeatures = latestFeatures.filter((feature) => !seenFeatures.includes(feature.name));

    if (newFeatures.length === 0) {
      return;
    }

    notifications.show({
      title: '✨ New features',
      message: (
        <div className="mt-2 space-y-2">
          <div>
            <ul className="space-y-1">
              {newFeatures.map((feature) => featureListItem(feature.name, feature.description))}
            </ul>
          </div>
        </div>
      ),
      color: 'blue',
      autoClose: 10000,
      position: 'top-center',
    });

    void setSeenFeatures((prev) => [...prev, ...newFeatures.map((f) => f.name)]);
  }, [hasMounted]);
}
